<template>
    <div :class="[
        'uik-container__wrapper uik-container__wrapper--' + ( horizontal ? 'horizontal' : 'vertical'),
        {'uik-container__wrapper--centerX': centerX},
        {'uik-container__wrapper--centerY': centerY}
    ]">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "UikContainer",
    props: {
        horizontal: { type: Boolean, default: false },
        margin: { type: Boolean, default: false },
        centerX: { type: Boolean, default: false },
        centerY: { type: Boolean, default: false }
    }
}
</script>

<style lang="scss">
.uik-container__wrapper--vertical {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    height: 100%;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    & > * {
        min-width: 1px;
    }
}
.uik-container__wrapper--horizontal {
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    & > * {
        min-width: 1px;
    }
}
.uik-container__wrapper--centerX {
    align-items: center;
}
.uik-container__wrapper--centerY {
    justify-content: center;
}
</style>
